import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';
import {PostProvidersDentalGuide} from 'domain/usecases/private/guide-flow/dental-guide/post-providers';
import {RemotePostProvidersDentalGuide} from 'data/usecases/private/guide-flow/dental-guide/remote-post-providers';

export const makePostProvidersDentalGuide = (): PostProvidersDentalGuide =>
	new RemotePostProvidersDentalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.odontoGuideProviders),
		makeAuthorizeHttpClientDecorator(),
	);
